var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/_core-js@2.4.1@core-js/library/modules/_shared.js
 ** module id = 105
 ** module chunks = 0 1
 **/